import { Alert, Typography } from "@octopus-energy/coral/atoms"
import { type SbBlokData, StoryblokComponent } from "@storyblok/react"

type StoryblokBlokLooperProps = {
    blocks: SbBlokData[]
    required?: boolean
}

export function StoryblokBlokLooper({ blocks, required = false }: StoryblokBlokLooperProps) {
    if (required && !blocks?.length) {
        return (
            <Alert severity="warning">
                <Typography color="inherit">
                    Le corps de la story semble vide. Veuillez y ajouter des bloks.
                </Typography>
            </Alert>
        )
    }

    return blocks.map((blok) => (
        <StoryblokComponent
            blok={blok}
            key={blok._uid}
        />
    ))
}
